"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var utils_2 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../../molecules/IconLink");

var _WorldMap_1 = require("./_WorldMap");

var HeaderLegacy_1 = require("./HeaderLegacy");

var MsbMetaBar =
/** @class */
function (_super) {
  __extends(MsbMetaBar, _super);

  function MsbMetaBar(props) {
    var _this = _super.call(this, props) || this;

    _this.closeTooltip = function () {
      window.requestAnimationFrame(function () {
        return _this.setState({
          tooltipOpen: false
        });
      });
      utils_2.WidgetEvents.removeBodyClose(_this.closeTooltip);
    };

    _this.closeWorldMap = function () {
      window.requestAnimationFrame(function () {
        return _this.setState({
          worldMapOpen: false
        });
      });
      utils_2.WidgetEvents.removeBodyClose(_this.closeWorldMap);
    };

    _this.state = {
      tooltipOpen: false,
      loginErrorOpen: false,
      worldMapOpen: false,
      searchValue: "",
      searchOpen: false
    };
    return _this;
  }

  MsbMetaBar.prototype.componentWillUnmount = function () {
    utils_2.WidgetEvents.removeBodyClose(this.closeTooltip);
    utils_2.WidgetEvents.removeBodyClose(this.closeWorldMap);
  };

  MsbMetaBar.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        applicationData = _a.applicationData,
        metaTree = _a.metaTree,
        resourceBundleData = _a.resourceBundleData,
        contentIncludesData = _a.contentIncludesData;
    var _b = this.state,
        loginErrorOpen = _b.loginErrorOpen,
        tooltipOpen = _b.tooltipOpen,
        worldMapOpen = _b.worldMapOpen,
        searchValue = _b.searchValue;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "metabar " + CSSPrefix_1.lsgPre + "msbmetabar"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "metabar-inner"
    }, React.createElement("div", {
      className: "mod mod-Suche " + (this.state.searchOpen ? "open" : "closed")
    }, React.createElement("form", {
      method: "post",
      action: "",
      name: "searchform",
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        HeaderLegacy_1.HeaderLegacy.openSearchPopup(contentIncludesData.searchDataUrl.url, contentIncludesData.searchDataUrl.popupHeight, contentIncludesData.searchDataUrl.popupWidth, searchValue);
      }
    }, React.createElement("input", {
      type: "search",
      className: "f-if-01",
      name: "SucheISDirekt",
      placeholder: contentIncludesData.searchDataUrl.placeholder,
      required: true,
      onInvalid: function onInvalid(e) {
        return e.preventDefault();
      },
      onChange: function onChange(e) {
        return _this.setState({
          searchValue: e.target.value
        });
      }
    }), React.createElement(IconLink_1.IconLink, {
      className: "f-sf-01",
      htmlAttrs: {
        type: "submit"
      },
      iconName: "i_211",
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: function onClick() {
        return _this.setState(function (prevState) {
          return {
            searchOpen: prevState.searchOpen === false
          };
        });
      }
    }, "/*TODO: should be a variable for i18n */ Suche"))), React.createElement("ul", {
      className: "mod mod-NavUser"
    }, React.createElement("li", null, applicationData.loginStatus === "FULL_LOGIN" && applicationData.actionTickerPendingOrders > 0 && React.createElement("a", {
      href: resourceBundleData.order_overview_url,
      className: "item item-messages",
      title: resourceBundleData["icon-button"]
    }, React.createElement(Icon_1.Icon, {
      name: "i_620"
    })), applicationData.loginStatus === "FULL_LOGIN" && applicationData.actionTickerPendingOrders === 0 && React.createElement("a", {
      href: resourceBundleData.order_overview_url,
      className: "item",
      title: resourceBundleData["icon-button"]
    }, React.createElement(Icon_1.Icon, {
      name: "i_620"
    })))), React.createElement("div", {
      className: "mod mod-NavMeta"
    }, React.createElement("ul", null, metaTree.map(function (item) {
      return React.createElement("li", null, React.createElement("a", {
        className: "mn-01",
        href: item.href,
        target: item.target,
        onClick: item.onClick
      }, item.label));
    }))), !applicationData.loginStatus && !applicationData.loginPageShown && React.createElement("div", {
      className: "mod mod-HeaderLogin",
      style: {
        "float": "right",
        position: "relative",
        marginBottom: "0",
        top: "9px"
      }
    }, React.createElement("form", {
      id: "headerLoginForm",
      action: applicationData.headerLoginURL + "?language=" + applicationData.cifLocale + "&pr=" + ("dummy" || applicationData.profileHolder.encryptedProfileString),
      method: "post",
      style: {
        textAlign: "right"
      }
    }, React.createElement("input", {
      type: "hidden",
      name: "headerLogin",
      value: "true"
    }), React.createElement("div", {
      className: "headerlogin-input-wrapper"
    }, React.createElement("div", null, React.createElement("input", {
      placeholder: resourceBundleData.user_id_label,
      className: "text-left required",
      type: "text",
      required: true,
      id: "teilnehmer",
      name: "teilnehmer",
      autoComplete: "off",
      pattern: "[0-9]{8}|[0-9]{10}|(?=(([0-9]+[^0-9]+)|([a-zA-Z]+[^a-zA-Z]+)|([@._\\-]+[^@._\\-]+)))[a-zA-Z0-9.@_\\-]{8,50}",
      maxLength: 50,
      tabIndex: 4,
      autoFocus: true,
      "data-h5-errorid": "invalid-teilnehmer"
    })), loginErrorOpen && React.createElement("div", {
      style: {
        position: "relative"
      }
    }, React.createElement("div", {
      className: "headerlogin-error-msg",
      id: "invalid-teilnehmer",
      style: {
        width: "200px"
      }
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("p", null, resourceBundleData.loginForm_teilnemer_invalid))))), React.createElement("div", {
      className: "headerlogin-input-wrapper"
    }, React.createElement("div", null, React.createElement("input", {
      placeholder: resourceBundleData.pin_label,
      type: "password",
      className: "text-left",
      required: true,
      id: "pin",
      name: "pin",
      autoComplete: "off",
      pattern: "^[A-Za-z0-9]{5,8}",
      maxLength: 8,
      tabIndex: 5,
      "data-h5-errorid": "invalid-pin"
    })), loginErrorOpen && React.createElement("div", {
      style: {
        position: "relative"
      }
    }, React.createElement("div", {
      className: "headerlogin-error-msg",
      id: "invalid-pin",
      style: {
        width: "200px"
      }
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: resourceBundleData.loginForm_pin_invalid
      }
    }))))), React.createElement("div", {
      className: "headerlogin-input-wrapper"
    }, React.createElement("div", {
      style: {
        marginTop: "6px"
      }
    }, React.createElement("a", {
      className: "info-box-link",
      onClick: function onClick() {
        return _this.setState(function (prevState) {
          return {
            tooltipOpen: prevState.tooltipOpen === false
          };
        });
      }
    }, "i")), tooltipOpen && React.createElement("div", {
      className: "info-box-msg",
      id: "headerLoginInfo",
      ref: function ref(r) {
        utils_2.WidgetEvents.removeBodyClose(_this.closeTooltip);
        if (r) utils_2.WidgetEvents.addBodyClose(r, _this.closeTooltip);
      }
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: resourceBundleData.header_login_info
      }
    })), React.createElement("span", {
      className: "close",
      onClick: this.closeTooltip
    }, "x"))), React.createElement("div", {
      style: {
        "float": "left"
      }
    }, React.createElement("button", {
      id: "headerLoginSubmit",
      className: "b-01 b-a-04 b-g-01 login",
      type: "submit",
      title: resourceBundleData.link_login_tooltip,
      onClick: function onClick() {
        return _this.setState(function (prevState) {
          return {
            loginErrorOpen: !prevState.loginErrorOpen
          };
        });
      }
    }, resourceBundleData.link_login_label)), React.createElement("div", {
      style: {
        clear: "both"
      }
    }))), applicationData.loginStatus && React.createElement("a", {
      href: "/lp/logout",
      "data-tracking-id": "logout",
      className: "btn b-01 b-a-05 b-g-01 iml-01 open",
      title: resourceBundleData.link_logout_tooltip
    }, resourceBundleData.link_logout_label))), worldMapOpen && React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "worldmap"])
    }, React.createElement("div", {
      tabIndex: -1,
      role: "dialog",
      className: "ui-dialog ui-corner-all ui-widget ui-widget-content ui-front",
      "aria-describedby": "lightbox-5733980",
      "aria-labelledby": "ui-id-1",
      ref: function ref(r) {
        utils_2.WidgetEvents.removeBodyClose(_this.closeWorldMap);
        if (r) utils_2.WidgetEvents.addBodyClose(r, _this.closeWorldMap);
      }
    }, React.createElement(IconLink_1.IconLink, {
      className: "close-link",
      iconName: Icon_1.Icon.Names.symbols___error,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.closeWorldMap
    }, "Close"), React.createElement("div", {
      className: "dialogContent ui-dialog-content ui-widget-content"
    }, React.createElement(_WorldMap_1.WorldMap, {
      url: "/portal/de/cb/miscellaneous-cb/metanavigation-cb/weltweit/worldmap_standard.html" // TODO

    })))));
  };

  return MsbMetaBar;
}(React.Component);

exports.MsbMetaBar = MsbMetaBar;